<template>
  <div v-if="availableDates.length">
   <Carousel class="calendar-slider" v-bind="carouselConfig">
    <Slide  @click="setDate(idx)" v-for="(availableDate, idx) in availableDates" :key="availableDate.date">
        <div :class="['dateui-card', { 'selected': currentIndex === idx }]">
          <time class="dateui-weekdays">
            <strong>{{ availableDate.day }}</strong>
            <span class="dateui-date">{{ availableDate.month }} {{ availableDate.date }}</span>
          </time>
        </div>
    </Slide>

    <template #addons>
      <div class="carousel-navigation">
        <Navigation />
      </div>
    </template>
  </Carousel>
</div>
</template>

<script setup lang="ts">
import {  onMounted, ref, defineExpose, provide } from "vue";
import { Carousel, Navigation, Slide } from "vue3-carousel";


interface AvailableDate {
  day: string;
  month: string;
  date: string;
}
  
const date = ref('')
const currentIndex = ref(-1)

const carouselConfig = {
  itemsToShow: 5,
  itemsToScroll: 5,
}

function setDate(idx: number) {
  date.value = ''
  currentIndex.value = idx
  const dateSelected = availableDates.value[idx]
  date.value = `${dateSelected.day} ${dateSelected.month}/${dateSelected.date}`
}

const availableDates = ref<AvailableDate[]>([]);
const slick = ref<any>(null);


const getNextTenDays = () => {
  const startDate = new Date(); 
  for (let i = 1; i <= 10; i++) {
    const x = new Date();
    x.setDate(startDate.getDate() + i);
    const dateComponent = x.toString().split(' ');
    availableDates.value.push({
      day: dateComponent[0],
      month: dateComponent[1],
      date: dateComponent[2].replace(/^0+/, ''),
    });
  }
};

onMounted(() => {
  getNextTenDays();
});

defineExpose({
  date
});
</script>

<style lang="scss">
.dateui {
  padding: 0 30px;

  &-card {
    background: $white;
    min-height: 66px;
    color: #444;
    font-size: 0.8rem;
    cursor: pointer;
    text-align: center;
    border-radius: 8px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    padding: 4px;
    border: 1px solid #dee2e6;
    width: 100%;

    &.selected {
      border-color: $primary;
      background: #f2faff;
    }
  }

  &-weekdays {
    margin-bottom: 4px;
    font-weight: 700;
    display: block;
  }

  &-date {
    font-size: 0.75rem;
    font-weight: 300;
    display: block;
  }

  .slick-slide {
    margin: 4px;
  }

}
.calendar-slider{
  margin-inline: 38px;
  .carousel__prev{
    left: -38px;
  }
  .carousel__next {
    right: -38px;
  }
}
.calendar-slider{
.carousel__slide{
  padding: 4px;
}
// .carousel__viewport{
//  padding-inline: 32px;
// }

.carousel__prev,
.carousel__next {
  min-height: 60px;
  border-radius: 8px;
}
}

</style>
